import styled from 'styled-components';

const SectionTitle = styled.h2`
  font-weight: bold;
  color: #333;
  text-align: center;
  line-height: 1.3;
  font-size: 1.8rem;
  margin-bottom: 10px;
`;

const Title = styled.h3`
  font-weight: 700;
  font-size: 1.15rem;
  color: #333;
  line-height: 1.5;
  margin-top: 30px;
  margin-bottom: 10px;
`;

const Content = styled.p`
  font-weight: 400;
  font-size: 0.87rem;
  line-height: 1.8;
`;

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  padding: 30px;
  justify-content: center;
  width: 60%;
  z-index: 0;
  animation: fadeIn cubic-bezier(0.23, 1, 0.32, 1) 1;
  opacity: 0;
  animation-fill-mode: forwards;
  animation-duration: 2s;
  animation-delay: 0.2s;

  @media only screen and (max-width: 767px) {
    width: 90%;
  }
`;

const Divider = styled.hr`
  width: 100%;
  color: #D3D3D3;
  opacity: 0.2;
  margin-top: 30px;
  margin-bottom: 30px;
`;

const ProfileWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: row;

  @media only screen and (max-width: 767px) {
    flex-direction: column;
  }
`;

const ProfileImage = styled.img`
  width: 220px;
  height: 150px;

  &:not(:first-child) {
    margin-left: 20px;
  }

  @media only screen and (max-width: 767px) {
    width: 264px;
    height: 180px;

    &:not(:first-child) {
      margin-top: 20px;
      margin-left: 0;
    }
  }
`;

const NewsItem = styled.div`
  background-color: #fff;
  padding: 30px;
  border: 1px solid #f2f2f2;
  border-radius: 10px;
  cursor: pointer;

  &:hover, &:focus {
    box-shadow: 1px 5px 15px rgba(0, 0, 0, 0.2);
  }

  &:not(:last-child) {
    margin-bottom: 20px;
  }

  h3 {
    font-size: 16px;
  }

  p {
    font-size: 14px;
    margin-top: 10px;
    line-height: 1.5;
  }

  > div {
    margin-top: 20px;
    display: flex;
    flex-direction: row;
    align-items: center;

    img {
      width: 45px;
    }

    p {
      color: #333;
      margin-left: 10px;
      margin-top: 0;
    }
  }
`;

export {
  SectionTitle,
  Title,
  Content,
  Wrapper,
  Divider,
  ProfileWrapper,
  ProfileImage,
  NewsItem,
};
